import React from 'react';
import { Navigate } from 'react-router-dom';
import { catalogHubPath } from './catalogRegistry';

const ChangeWorkGroupsPage: React.FC = () => <Navigate to={catalogHubPath('work-groups')} replace />;

export default ChangeWorkGroupsPage;
